import api from "@services/apiList";
import instance from "@services/services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";

const {SettingsApi} = api

export const menuRearrange = async (params: {
  clinicId: number;
  currentOrder: number;
  newOrder: number;
}):Promise<ResponseType<string>> => {
    const result = await instance.post(SettingsApi.menuRearrange,params)
    return result.data
};
